import React, {useContext} from "react";
import './ModifierDescription.less';
import {TranslationsContext} from "../../../contexts/translations-context";
import {Button} from "../../elements/button/Button";
import {getSafeTranslation} from "../../../helpers/localization.helper";
import {DrawerDescription} from "../../elements/drawer-description/DrawerDescription";
import {DrawerPopup} from "../../dialog-layout/drawer-popup/DrawerPopup";

export const ModifierDescription = ({description, onDoneClick, onOverlayClick}) => {
	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={getSafeTranslation('ModifierDescription.title', translations)}
		rightControl={<Button
			onClick={onDoneClick}
			isAutoWidth={false}
		>
			{getSafeTranslation('ModifierDescription.doneButtonCaption', translations)}
		</Button>
		}
		onOverlayClick={onOverlayClick}
	>
		<DrawerDescription text={description} isFullSize={true}/>

	</DrawerPopup>
}
